import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo } from "react";
import { PlatformOrderInfo } from ".";
import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import WaybillTemplateFormItem from "./WaybillTemplateFormItem";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import AliWaybillTemplateFormItem from "./AliWaybillTemplateFormItem";
import { classifyPlatformOrderInfo } from "./utils";
import OtherDropShippingSupplierWaybillTemplateFormItem from "./OtherDropShippingSupplierWaybillTemplateFormItem";

interface WaybillTemplateFormItemsProps {
    platformOrderInfo: PlatformOrderInfo;

    defaultTemplateId?: number;
}

const WaybillTemplateExtra = React.memo(() => (
    <Row>
        <Col span={4}></Col>
        <Col span={20}>
            <div className="error">
                目前没有快递单模板信息,请先<Link to="/setting/waybillTemplate">点击这里添加快递单模板</Link>
            </div>
        </Col>
    </Row>
));

const WaybillTemplateFormItems: React.FC<WaybillTemplateFormItemsProps> = function (props) {
    const { platformOrderInfo, defaultTemplateId } = props;

    const globalStore = useGlobalStore();
    const loading = globalStore.waybillPrintStore.waybillTemplatesLoading;

    useEffect(() => {
        globalStore.waybillPrintStore.ensureWaybillTemplates();
    }, []);

    const { aliPlatformOrderInfo, standardPlatformOrderInfo, otherDropShippingSupplierPlatformOrderInfo } = useMemo(
        () => {
            return classifyPlatformOrderInfo(platformOrderInfo);
        },
        [platformOrderInfo],
    );

    const showAliFormItem = !!Object.keys(aliPlatformOrderInfo).length;
    const showOtherDropShippingSupplierFormItem = !!Object.keys(otherDropShippingSupplierPlatformOrderInfo).length;

    return (
        <>
            {Object.keys(standardPlatformOrderInfo).map((platform: MultiShopSelectPlatformType) => {
                if (!platformOrderInfo?.[platform]?.length) {
                    return null;
                }

                return (
                    <WaybillTemplateFormItem key={platform} platform={platform} defaultTemplateId={defaultTemplateId} />
                );
            })}

            {showAliFormItem ? (
                <AliWaybillTemplateFormItem
                    aliPlatformOrderInfo={aliPlatformOrderInfo}
                    defaultTemplateId={defaultTemplateId}
                />
            ) : null}

            {showOtherDropShippingSupplierFormItem ? (
                <OtherDropShippingSupplierWaybillTemplateFormItem
                    platformOrderInfo={otherDropShippingSupplierPlatformOrderInfo}
                    defaultTemplateId={defaultTemplateId}
                />
            ) : null}

            {!loading && globalStore.waybillPrintStore.waybillTemplates?.length === 0 ? <WaybillTemplateExtra /> : null}
        </>
    );
};

export default observer(WaybillTemplateFormItems);
